import { arrayOf, bool, func } from 'prop-types';
import React, { useState } from 'react';
import { withRouter } from 'react-router';

import { getTooltipButtonWithText } from '../../generic/Tooltip';
import {
  historyShape,
  merchantShape,
  opportunityShape,
} from '../../prop-types';
import withApiRequest from '../../REST/with-api-request';
import HELP_TEXTS from '../help-texts';
import ExpectedRevenuesModal from './ExpectedRevenuesModal';
import handleCloneRequest from './handle-clone-request';

const ButtonWithTooltip = getTooltipButtonWithText(HELP_TEXTS);

function CloneOpportunity({
  opportunity,
  onRequest,
  loading,
  history,
  merchants,
}) {
  const [openModal, setOpenModal] = useState(false);

  const onClick = ({ expectedRevenueFields }) =>
    onRequest(opportunity, expectedRevenueFields, merchants).then(opp =>
      history.push(`/opportunities/${opp.id}/show`),
    );

  const toggleModal = () => setOpenModal(!openModal);

  return (
    <>
      <ExpectedRevenuesModal
        open={openModal}
        toggleModal={toggleModal}
        onClick={onClick}
      />
      <ButtonWithTooltip
        helpKey="cloneOpportunity"
        section="navigation"
        color="primary"
        onClick={toggleModal}
        disabled={loading}
      >
        Clone
      </ButtonWithTooltip>
    </>
  );
}

CloneOpportunity.propTypes = {
  opportunity: opportunityShape.isRequired,
  onRequest: func.isRequired,
  loading: bool.isRequired,
  history: historyShape.isRequired,
  merchants: arrayOf(merchantShape).isRequired,
};

export default withApiRequest({
  query: handleCloneRequest,
  error: 'flash',
  successMessage: 'Opportunity cloned successfully',
})(withRouter(CloneOpportunity));
